"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSerializerHTTPData = exports.UserSerializer = void 0;
var models_1 = require("../../models");
/**
 * Serializes user - response received from `ProfileClient.findCurrent`
 *
 * @author javier.perez
 */
var UserSerializer = /** @class */ (function () {
    function UserSerializer() {
    }
    UserSerializer.prototype.serialize = function (_a) {
        var id = _a.id, firstName = _a.firstName, lastName = _a.lastName, avatar = _a.avatar, roles = _a.roles, school = _a.school, archived = _a.archived, district = _a.district, schools = _a.schools, userId = _a.userId, globalId = _a.globalId, classes = _a.classes;
        return new models_1.User({
            id: id,
            firstName: firstName,
            lastName: lastName,
            avatar: avatar,
            roles: roles,
            school: school,
            schools: schools,
            archived: archived,
            districtId: district === null || district === void 0 ? void 0 : district.id,
            userId: userId,
            globalId: globalId,
            districtName: district === null || district === void 0 ? void 0 : district.name,
            classes: classes ? classes.map(function (c) { return new models_1.Class({ id: c.id, name: c.name }); }) : [],
        });
    };
    return UserSerializer;
}());
exports.UserSerializer = UserSerializer;
/**
 * Serialize user - response received when directly called `roster/profile`
 *
 * [Taken from: https://github.com/greatmindsorg/dp-acma-dawn-sdk/blob/bb8cad95a00042069092656fb80aa6cd26ac66d6/lib/acma/serializers/user.serializer.ts]
 */
var UserSerializerHTTPData = /** @class */ (function () {
    function UserSerializerHTTPData() {
    }
    UserSerializerHTTPData.prototype.serializeOne = function (_a) {
        var id = _a.id, name = _a.name, avatar = _a.avatar, school = _a.school, roles = _a.roles, district = _a.district, archived = _a.archived, userId = _a.userId, globalId = _a.globalId;
        return {
            id: id,
            district: district,
            firstName: name ? name.first : undefined,
            lastName: name ? name.last : undefined,
            roles: roles,
            avatar: avatar,
            school: (school && school.length ? school[0] : undefined),
            schools: school,
            archived: archived,
            userId: userId,
            globalId: globalId,
        };
    };
    return UserSerializerHTTPData;
}());
exports.UserSerializerHTTPData = UserSerializerHTTPData;
